import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NewHomeComponent } from './pages/new-home/new-home.component';
import { DynamicGuardsService } from '@app-core/services/dynamic-guards/dynamic-guards.service';

const dynamicGuards = () => {
  return inject(DynamicGuardsService).getGuards();
};

const routes: Routes = [
  {
    path: 'home',
    canActivate: [dynamicGuards],
    component: NewHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
